<section class="browser-block-page">
  <div class="browser-block-card">
    <p class="eyebrow">{{ "UNSUPPORTED_BROWSER.EYEBROW" | translate }}</p>
    <h1>{{ "UNSUPPORTED_BROWSER.TITLE" | translate }}</h1>
    <p class="description">
      {{ "UNSUPPORTED_BROWSER.DESCRIPTION" | translate }}
    </p>
    <p class="guidance">
      {{ "UNSUPPORTED_BROWSER.GUIDANCE" | translate }}
    </p>
  </div>
</section>